module.exports = __webpack_public_path__ + "img/img_banner.8b5c66c7.png";